import RcDomainMap from "@/domain/common/RcDomainMap.js";
import CheckListVersion from "./CheckListVersion.js";

export default class CheckListVersionMap extends RcDomainMap {

  static MODEL_NAME = "CheckListVersionMap";

  constructor(domain, data) {
    super(domain, data, CheckListVersionMap.MODEL_NAME);
  }

  list() {
    return this.keys().map(key => this.getCheckListVersion(key));
  }

  getCheckListVersion(key) {
    return new CheckListVersion(this.domain, super.get(key));
  }

  copy() {
    var data = this._copy();
    return new CheckListVersionMap(this.domain, data);
  }
}
